import { cn } from "@/lib/utils";

/**
 * One segment per module, filled when the module has lessons - `LN-UI04`.
 *
 * A track is published before it is finished (Learn C went live with 7 of its
 * 18 modules written), and the founder chose on 2026-09-23 to say so rather than
 * print "18 modules" as if they were all there. The strip is the picture of that
 * sentence; the sentence itself sits next to it, so the strip is `role="img"`
 * with the same words as its label and never the only place the count lives.
 */
export function LearnModuleStrip({
  modules,
  label,
  className,
}: {
  /** `true` for a module that has at least one lesson, in syllabus order. */
  modules: readonly boolean[];
  label: string;
  className?: string;
}) {
  if (modules.length === 0) return null;
  return (
    <div
      aria-label={label}
      className={cn("grid gap-1", className)}
      role="img"
      style={{ gridTemplateColumns: `repeat(${modules.length}, minmax(0, 1fr))` }}
    >
      {modules.map((filled, index) => (
        <span
          className={cn("h-1.5 rounded-full", filled ? "bg-primary" : "bg-neutral-200")}
          key={index}
        />
      ))}
    </div>
  );
}
